export default __webpack_public_path__ + "static/media/blog-39-3.4d8b319f.png";